/* eslint-disable react/no-this-in-sfc */
/* eslint-disable func-names */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Avatar, Badge, Box, Flex, FormLabel, Text } from '@chakra-ui/react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import { useFormValidationToast } from '../../../services/actionToast';
import { InputForm } from '../../inputs/forms/InputForm';
import { getFetchData, useFetch } from '../../../hooks/useFetch';
import { SelectInputForm } from '../../inputs/forms/SelectInputForm';
import { MaskedInputForm } from '../../inputs/forms/MaskedInputForm';
import { CepField } from '../../inputs/forms/CepField';
import { SwitchInputForm } from '../../inputs/forms/SwitchInputForm';
import { NewResponsible, ResponsiblePicker } from '../../inputs/forms/ResponsiblePicker';
import { NewResponsibleDialog } from '../../inputs/forms/ResponsiblePicker/NewResponsibleDialog';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  FormActions,
  FormRow,
  FormSection,
  FormShell,
} from '../../ui';
import { getFormattedLabel } from '../../../utils/FormatFunctions';
import { getResponsibleValidationShape } from './validation';

interface InstitutionFormProps {
  defaultValues?: any;
}

interface FormInputsProps {
  name: string;
  value: any;
  placeholder?: string;
  label: string;
  yup: any;
}

export default function InstitutionForm({ defaultValues }: InstitutionFormProps) {
  const validationToast = useFormValidationToast();
  const baseUrl = '/v1/admin/institutions';
  const { requestApi: reqApiInstitutions } = useFetch(baseUrl);
  const {
    requestApi: reqApiSecretaries,
    data: dataSecretaries,
    loading: loadingSecretaries,
  } = useFetch('/v1/admin/secretaries');
  const {
    requestApi: reqApiModules,
    data: dataModules,
    loading: loadingModules,
  } = useFetch('/v1/admin/material-modules');
  const { requestApi: reqApiUsers } = useFetch('/v1/admin/users');
  const { data: optionsSecretaries, pagination: paginationSecretaries } =
    getFetchData(dataSecretaries);
  const { requestApi: reqApiCodepost, error: errorCodepost } = useFetch('/v1/client/address');
  const { itemId } = useParams();
  const navigate = useNavigate();
  const [loadingCodepost, setLoadingCodepost] = useState<any>(false);
  const [address, setAddress] = useState<any>({});
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [moduleDetails, setModuleDetails] = useState<any>(null);
  const [selectedExistingUsers, setSelectedExistingUsers] = useState<any[]>([]);
  const [userSearchResults, setUserSearchResults] = useState<any[]>([]);
  const [isSearchingUsers, setIsSearchingUsers] = useState(false);
  const [eligibleUsers, setEligibleUsers] = useState<any[]>([]);
  const [loadingEligibleUsers, setLoadingEligibleUsers] = useState(false);

  const optionsType = [
    {
      label: 'Pública',
      value: 'PUBLICA',
    },
    {
      label: 'Privada',
      value: 'PRIVADA',
    },
  ];

  const templateStrategyOptions = [
    {
      label: 'Aplicar template padrão',
      value: 'DEFAULT',
    },
    {
      label: 'Aplicar template manualmente depois',
      value: 'MANUAL',
    },
  ];

  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs: FormInputsProps[] = [
    {
      name: 'name',
      value: defaultValues?.name ?? '',
      placeholder: 'Nome da instituição',
      label: 'Nome',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'secretary_id',
      value: defaultValues?.secretary ? getFormattedLabel(defaultValues?.secretary) : null,
      placeholder: 'Selecione uma secretaria ou "Sem Secretaria"',
      label: 'Qual secretaria?',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'template_strategy',
      value: defaultValues?.template_strategy
        ? templateStrategyOptions.find((item) => item.value === defaultValues.template_strategy)
        : templateStrategyOptions.find((item) => item.value === 'DEFAULT'), // Mudado de MANUAL para DEFAULT
      placeholder: 'Selecione uma opção',
      label: 'Qual template deseja aplicar?',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'module_id',
      value: defaultValues?.module_id
        ? {
            label:
              defaultValues?.module?.name && defaultValues.module.name.trim() !== ''
                ? defaultValues.module.name
                : `Módulo ${defaultValues.module_id}`,
            value: defaultValues.module_id,
          }
        : null,
      placeholder: 'Selecione um template personalizado',
      label: 'Templates personalizados',
      yup: Yup.mixed(),
    },
    {
      name: 'site',
      value: defaultValues?.site ?? '',
      placeholder: 'Site da instituição',
      label: 'Site',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'type',
      value: defaultValues?.type
        ? optionsType.find((item) => item.value === defaultValues?.type)
        : null,
      placeholder: 'Tipo de instituição',
      label: 'Tipo',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'cell_phone',
      value: defaultValues?.cell_phone ?? '',
      placeholder: 'Telefone da instituição',
      label: 'Telefone',
      yup: Yup.string(),
    },
    {
      name: 'code_post',
      value: defaultValues?.address?.code_post ?? '',
      placeholder: 'CEP da instituição',
      label: 'CEP',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'city_id',
      value: defaultValues?.address?.city?.id ?? '',
      placeholder: '',
      label: 'Cidade',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'city_name',
      value: defaultValues?.address?.city?.name ?? '',
      placeholder: 'Cidade da instituição',
      label: 'Cidade',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'state_name',
      value: defaultValues?.address?.city?.state?.name ?? '',
      placeholder: 'Estado da instituição',
      label: 'Estado',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'street',
      value: defaultValues?.address?.street ?? '',
      placeholder: 'Rua da instituição',
      label: 'Rua',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'number',
      value: defaultValues?.address?.number ?? '',
      placeholder: 'Número da instituição',
      label: 'Número',
      yup: Yup.string(),
    },
    {
      name: 'district',
      value: defaultValues?.address?.district ?? '',
      placeholder: 'Bairro da instituição',
      label: 'Bairro',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'complement',
      value: defaultValues?.address?.complement ?? '',
      placeholder: 'Complemento da instituição',
      label: 'Complemento',
      yup: Yup.string(),
    },
    {
      name: 'responsible',
      value: defaultValues?.responsible ?? '',
      placeholder: 'Nome do responsável',
      label: 'Nome',
      yup: Yup.string(),
    },
    {
      name: 'email',
      value: defaultValues?.email ?? '',
      placeholder: 'Email do responsável',
      label: 'Email',
      yup: Yup.string().email('Email inválido'),
    },
    {
      name: 'responsible_phone',
      value: defaultValues?.responsible_phone ?? '',
      placeholder: 'Telefone do responsável',
      label: 'Telefone',
      yup: Yup.string(),
    },
    {
      name: 'function',
      value: defaultValues?.function ?? 'Responsável pela instituição',
      placeholder: 'Função do responsável',
      label: 'Função',
      yup: Yup.string(),
    },
    {
      name: 'status',
      value: defaultValues?.status ?? true,
      label: 'Status',
      yup: Yup.boolean(),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });

  // Calcula se há responsáveis existentes selecionados
  const hasExistingResponsibles = selectedExistingUsers.length > 0;

  // Schema dinâmico: se há usuários existentes selecionados, os campos de novo responsável não são obrigatórios
  // IMPORTANTE: useMemo com dependência de hasExistingResponsibles para recriar schema quando mudar
  const schema = useMemo(
    () =>
      Yup.object().shape({
        ...yupschema,
        ...getResponsibleValidationShape(),
      }),
    [hasExistingResponsibles]
  );

  const moduleItems = useMemo(() => {
    if (!dataModules) return [];
    const response = getFetchData(dataModules);
    if (Array.isArray(response?.data)) return response.data;
    if (Array.isArray(dataModules)) return dataModules as any[];
    return [];
  }, [dataModules]);

  const moduleOptions = useMemo(
    () =>
      moduleItems.map((item: any) => ({
        label: item?.name && item.name.trim() !== '' ? item.name : `Módulo ${item?.id}`,
        value: item?.id,
      })),
    [moduleItems]
  );

  const defaultModuleOption = useMemo(() => {
    const defaultModule = moduleItems.find((item: any) => item?.is_default);
    if (!defaultModule) return null;
    return {
      label:
        defaultModule?.name && defaultModule.name.trim() !== ''
          ? defaultModule.name
          : `Módulo ${defaultModule?.id}`,
      value: defaultModule?.id,
    };
  }, [moduleItems]);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    control,
    trigger,
    formState: { errors, isSubmitting, isSubmitted },
  } = useForm({
    resolver: yupResolver(schema, { context: { hasExistingUsers: hasExistingResponsibles } }),
    defaultValues: defaultValuesSchema,
  });

  const name = formInputs.find((field) => field.name === 'name');
  const secretary = formInputs.find((field) => field.name === 'secretary_id');
  const templateStrategy = formInputs.find((field) => field.name === 'template_strategy');
  const moduleField = formInputs.find((field) => field.name === 'module_id');
  const cellphone = formInputs.find((field) => field.name === 'cell_phone');
  const site = formInputs.find((field) => field.name === 'site');
  const type = formInputs.find((field) => field.name === 'type');
  const codePost = formInputs.find((field) => field.name === 'code_post');
  const city = formInputs.find((field) => field.name === 'city_name');
  const state = formInputs.find((field) => field.name === 'state_name');
  const street = formInputs.find((field) => field.name === 'street');
  const number = formInputs.find((field) => field.name === 'number');
  const district = formInputs.find((field) => field.name === 'district');
  const complement = formInputs.find((field) => field.name === 'complement');
  const status = formInputs.find((field) => field.name === 'status');
  const templateStrategyValue = watch('template_strategy');
  const moduleSelectedValue = watch('module_id');
  const isDefaultTemplateSelected =
    templateStrategyValue?.value === 'DEFAULT' || templateStrategyValue === 'DEFAULT';
  const isEditing = Boolean(itemId);

  // Função para recarregar responsáveis vinculados
  const reloadResponsibles = React.useCallback(async () => {
    if (!itemId) return;

    try {
      const response = await reqApiUsers(
        'get',
        {},
        `/v1/admin/institutions/${itemId}/additional-responsibles`
      );
      if (response?.data?.data && Array.isArray(response.data.data)) {
        setSelectedExistingUsers((prev) => mergeUniqueUsers([...prev, ...response.data.data]));
      }
    } catch {
      setSelectedExistingUsers([]);
    }
  }, [itemId, reqApiUsers]);

  const onSubmit = async (values: any) => {
    const templateStrategyValueNormalized =
      values.template_strategy?.value ?? values.template_strategy ?? 'MANUAL';
    const resolvedModuleId =
      templateStrategyValueNormalized === 'DEFAULT'
        ? values.module_id?.value ?? defaultModuleOption?.value ?? null
        : null;

    const params = {
      ...values,
      type: values.type.value,
      // Se secretary_id for 0 (sem secretaria), enviar null
      secretary_id: values.secretary_id?.value === 0 ? null : values.secretary_id?.value ?? null,
      template_strategy: templateStrategyValueNormalized,
      module_id: resolvedModuleId,
      // Se selecionou usuários existentes, enviar os IDs
      ...(selectedExistingUsers.length > 0
        ? {
            existing_user_ids: selectedExistingUsers.map((u) => u.id),
          }
        : {}),
      address: {
        code_post: values.code_post,
        city_id: Number(values.city_id),
        street: values.street,
        number: values.number,
        district: values.district,
        complement: values.complement,
      },
      code_post: _,
      city_id: _,
      city_name: _,
      state_name: _,
      street: _,
      number: _,
      district: _,
      complement: _,
    };
    const { status: resStatus } = await reqApiInstitutions(
      defaultValues?.name ? 'put' : 'post',
      params,
      defaultValues?.name ? `${baseUrl}/${itemId}` : null
    );

    if (resStatus === 200 || resStatus === 201) {
      await reloadResponsibles();
      navigate('/institutions/list');
    }
  };

  const getCep = async (cep) => {
    const { data, status: statusRes } = await reqApiCodepost('get', { params: { code_post: cep } });
    if (statusRes === 200) {
      setAddress(data?.data);
    } else {
      setAddress({});
    }
    setLoadingCodepost(false);
  };

  // Hook para buscar usuários com filtro
  const { requestApi: reqApiUserSearch } = useFetch('/v1/admin/users/search');

  // Buscar usuários existentes para vincular como responsável
  const searchUsers = useMemo(
    () =>
      _.debounce(async (searchTerm: string, secretaryId: number | null) => {
        if (!searchTerm || searchTerm.length < 3) {
          setUserSearchResults([]);
          return;
        }

        setIsSearchingUsers(true);

        try {
          const params: any = { q: searchTerm, exclude_responsible: true };

          if (secretaryId) {
            params.secretary_id = secretaryId;
          }

          const { data, status: statusRes } = await reqApiUserSearch('get', { params });

          if (statusRes === 200) {
            setUserSearchResults(data?.data || []);
          } else {
            setUserSearchResults([]);
          }
        } catch {
          setUserSearchResults([]);
        } finally {
          setIsSearchingUsers(false);
        }
      }, 500),
    [reqApiUserSearch]
  );

  // Handler para selecionar usuário existente (permite múltiplos)
  const mergeUniqueUsers = (users: any[]) => {
    const unique = new Map();
    users.forEach((user) => {
      if (user && user.id) {
        unique.set(user.id, {
          id: user.id,
          name: user.name,
          email: user.email,
          cell_phone: user.cell_phone,
        });
      }
    });
    return Array.from(unique.values());
  };

  const handleSelectExistingUser = (user: any) => {
    setSelectedExistingUsers((prev) => mergeUniqueUsers([...prev, user]));
    setUserSearchResults([]);
    setValue('responsible', '');
    setValue('email', '');
    setValue('responsible_phone', '');
  };

  // Handler para remover usuário da seleção
  const handleRemoveExistingUser = (userId: number) => {
    setSelectedExistingUsers((prev) => prev.filter((u) => u.id !== userId));
  };

  const [newResponsibleOpen, setNewResponsibleOpen] = useState(false);
  const manualValues = watch(['responsible', 'email', 'responsible_phone', 'function']);
  const manualResponsible: NewResponsible | null =
    manualValues[0] || manualValues[1]
      ? {
          name: manualValues[0] ?? '',
          email: manualValues[1] ?? '',
          phone: manualValues[2] ?? '',
          function: manualValues[3] ?? '',
        }
      : null;
  const manualResponsibleError =
    !itemId && selectedExistingUsers.length === 0 && !manualResponsible
      ? (errors as any).responsible?.message ??
        (errors as any).email?.message ??
        (errors as any).responsible_phone?.message
      : undefined;

  const applyManualResponsible = (value: NewResponsible) => {
    setSelectedExistingUsers([]);
    setUserSearchResults([]);
    setValue('responsible', value.name, { shouldValidate: true, shouldDirty: true });
    setValue('email', value.email, { shouldValidate: true, shouldDirty: true });
    setValue('responsible_phone', value.phone, { shouldValidate: true, shouldDirty: true });
    setValue('function', value.function ?? 'Responsável pela instituição', {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const clearManualResponsible = () => {
    setValue('responsible', '');
    setValue('email', '');
    setValue('responsible_phone', '');
  };

  const handleUserSearchTerm = (searchTerm: string) => {
    const selectedSecretary = watch('secretary_id');
    // Se for 0 (sem secretaria), passar null para buscar todos
    const secretaryId = selectedSecretary?.value === 0 ? null : selectedSecretary?.value || null;

    searchUsers(searchTerm, secretaryId);
  };

  useEffect(() => {
    if (defaultValues?.name) {
      reset(defaultValuesSchema);
      getCep(watch('code_post').replace(/\D/g, ''));
    }
  }, [defaultValues]);

  useEffect(() => {
    reqApiModules('get');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (defaultValues?.module_id && moduleOptions.length > 0) {
      const selectedModule = moduleOptions.find(
        (option) => option.value === defaultValues.module_id
      );
      if (selectedModule) {
        setValue('module_id', selectedModule);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues?.module_id, moduleOptions]);

  useEffect(() => {
    setValue('city_id', address?.city?.id);
    setValue('city_name', address?.city?.name);
    setValue('state_name', address?.city?.state?.name);
    setValue('street', address?.street);
    setValue('district', address?.district);
  }, [address]);

  useEffect(() => {
    if (watch('code_post').replace(/\D/g, '').length < 8) {
      setAddress(null);
      return;
    }
    if (!isFirstRender) {
      setLoadingCodepost(true);
      const timeout = setTimeout(() => {
        getCep(watch('code_post').replace(/\D/g, ''));
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [watch('code_post')]);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  useEffect(() => {
    // Quando DEFAULT está selecionado, limpa o module_id (não precisa)
    if (isDefaultTemplateSelected) {
      setValue('module_id', null);
    }
    // Quando MANUAL, limpa também inicialmente
    else if (!moduleSelectedValue) {
      setValue('module_id', null);
    }
  }, [isDefaultTemplateSelected, setValue]);

  // Buscar detalhes do módulo selecionado (apenas para modo MANUAL)
  useEffect(() => {
    if (!moduleSelectedValue?.value || isDefaultTemplateSelected) {
      setModuleDetails(null);
      return;
    }

    // Buscar módulo selecionado dos dados já carregados
    const selectedModule = moduleItems.find((m: any) => m.id === moduleSelectedValue.value);
    if (selectedModule) {
      setModuleDetails(selectedModule);
    }
  }, [moduleSelectedValue, isDefaultTemplateSelected, moduleItems]);

  useEffect(() => {
    if (isEditing && itemId) {
      const loadResponsibles = async () => {
        try {
          const additional = await reqApiUsers(
            'get',
            {},
            `/v1/admin/institutions/${itemId}/additional-responsibles`
          );

          if (additional?.data?.data && Array.isArray(additional.data.data)) {
            setSelectedExistingUsers((prev) =>
              mergeUniqueUsers([...prev, ...additional.data.data])
            );
          }
        } catch {
          setSelectedExistingUsers([]);
        }
      };

      loadResponsibles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditing, itemId]);

  useEffect(() => {
    if (isEditing && defaultValues?.responsible_user) {
      setSelectedExistingUsers((prev) =>
        mergeUniqueUsers([...prev, defaultValues.responsible_user])
      );
    }
  }, [isEditing, defaultValues?.responsible_user]);

  useEffect(() => {
    if (trigger && isSubmitted) {
      trigger(['responsible', 'email', 'responsible_phone', 'function']);
    }
  }, [selectedExistingUsers.length, trigger, isSubmitted]);

  // Carregar lista de usuários elegíveis para responsável de instituição
  useEffect(() => {
    const loadEligibleUsers = async () => {
      setLoadingEligibleUsers(true);
      try {
        // TODO: Melhorar backend para filtrar usuários já vinculados a outras instituições
        // Buscar usuários com group_id=7 (Responsável pela Instituição)
        const params = {
          group_id: 7,
          per_page: 50, // Limitar resultados
        };
        const response = await reqApiUsers('get', { params });
        const users = response?.data?.data || [];

        // Por enquanto, exibir todos os usuários com group_id=7
        // Futuramente, filtrar aqui os que já estão em outras instituições
        setEligibleUsers(users);
      } catch {
        setEligibleUsers([]);
      } finally {
        setLoadingEligibleUsers(false);
      }
    };

    loadEligibleUsers();
  }, []);

  const isEdit = Boolean(defaultValues?.name);

  return (
    <FormShell
      title={isEdit ? 'Editar Instituição' : 'Criar Instituição'}
      backTo="/institutions/list"
      backLabel="Instituições"
    >
      <Box
        as="form"
        noValidate
        onSubmit={handleSubmit(onSubmit, validationToast)}
        display="flex"
        flexDirection="column"
        gap="16px"
      >
        <FormSection title="Informações Básicas">
          <FormRow>
            <InputForm
              name={name?.name}
              label={name?.label}
              placeholder={name?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <SelectInputForm
              name={type?.name}
              label={type?.label}
              options={optionsType}
              placeholder={type?.placeholder}
              isRequired
              control={control}
              errors={errors}
            />
          </FormRow>

          <Flex gap={5} flexWrap="wrap">
            <Box flex={2} minW="240px">
              <SelectInputForm
                name={secretary?.name}
                label={secretary?.label}
                options={[
                  { label: '⚠️ Sem Secretaria (Instituição Independente)', value: 0 },
                  ...(optionsSecretaries?.map((item) => getFormattedLabel(item)) ?? []),
                ]}
                isLoading={loadingSecretaries}
                pagination={paginationSecretaries}
                getOptions={(filters) => reqApiSecretaries('get', { params: { ...filters } })}
                placeholder={secretary?.placeholder}
                control={control}
                errors={errors}
                isRequired
              />
            </Box>

            <Box flex={2} minW="240px">
              <SelectInputForm
                name={templateStrategy?.name}
                label={templateStrategy?.label}
                options={templateStrategyOptions}
                placeholder={templateStrategy?.placeholder}
                control={control}
                errors={errors}
                isRequired
              />
            </Box>

            {!isDefaultTemplateSelected && templateStrategyValue?.value === 'MANUAL' && (
              <Box flex={2} minW="240px">
                <SelectInputForm
                  name={moduleField?.name}
                  label={moduleField?.label}
                  options={moduleOptions}
                  isLoading={loadingModules}
                  placeholder={moduleField?.placeholder}
                  control={control}
                  errors={errors}
                />
                {moduleSelectedValue && (
                  <Box mt={2}>
                    <details>
                      <summary
                        style={{
                          cursor: 'pointer',
                          color: '#3182ce',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        📋 Veja o que contempla neste módulo
                      </summary>
                      <Box
                        mt={2}
                        p={4}
                        bg="blue.50"
                        borderRadius="md"
                        fontSize="sm"
                        border="1px solid"
                        borderColor="blue.200"
                      >
                        {moduleDetails ? (
                          <>
                            <Text fontWeight="bold" mb={3} color="blue.800" fontSize="md">
                              {moduleSelectedValue.label}
                            </Text>

                            {moduleDetails.description && (
                              <Text fontSize="sm" color="content.strong" mb={3}>
                                {moduleDetails.description}
                              </Text>
                            )}

                            <Box mb={3} p={3} bg="white" borderRadius="md" boxShadow="sm">
                              <Text fontWeight="semibold" mb={2} color="content.strong">
                                📊 Informações deste template:
                              </Text>
                              <Flex direction="column" gap={2}>
                                <Flex align="center" gap={2}>
                                  <Text fontWeight="bold" color="blue.600" fontSize="lg">
                                    {moduleDetails.templates_count || 0}
                                  </Text>
                                  <Text fontSize="xs" color="content.body">
                                    Templates de materiais vinculados
                                  </Text>
                                </Flex>
                                <Flex align="center" gap={2}>
                                  <Text fontWeight="bold" color="green.600" fontSize="lg">
                                    {moduleDetails.institutions_count || 0}
                                  </Text>
                                  <Text fontSize="xs" color="content.body">
                                    Instituições já utilizando este módulo
                                  </Text>
                                </Flex>
                                {moduleDetails.is_default && (
                                  <Flex
                                    align="center"
                                    gap={2}
                                    p={2}
                                    bg="yellow.50"
                                    borderRadius="md"
                                    border="1px solid"
                                    borderColor="yellow.300"
                                  >
                                    <Text fontSize="xs" fontWeight="bold" color="yellow.700">
                                      ⭐ Este é o módulo padrão recomendado
                                    </Text>
                                  </Flex>
                                )}
                              </Flex>
                            </Box>

                            {moduleOptions.length > 1 && (
                              <Box p={3} bg="gray.50" borderRadius="md" fontSize="xs">
                                <Text fontWeight="semibold" mb={2} color="content.strong">
                                  🔄 Comparado aos outros templates disponíveis:
                                </Text>
                                <Flex direction="column" gap={1.5}>
                                  {moduleOptions
                                    .filter((opt) => opt.value !== moduleSelectedValue.value)
                                    .slice(0, 4)
                                    .map((opt) => {
                                      const otherModule = moduleItems.find(
                                        (m: any) => m.id === opt.value
                                      );
                                      return (
                                        <Flex
                                          key={opt.value}
                                          align="center"
                                          justify="space-between"
                                          p={2}
                                          bg="white"
                                          borderRadius="sm"
                                        >
                                          <Text
                                            color="content.strong"
                                            fontWeight="medium"
                                            fontSize="xs"
                                          >
                                            {opt.label || `Módulo ${opt.value}`}
                                          </Text>
                                          <Flex gap={3} fontSize="xs">
                                            <Text color="blue.600">
                                              <strong>{otherModule?.templates_count || 0}</strong>{' '}
                                              templates
                                            </Text>
                                            <Text color="green.600">
                                              <strong>
                                                {otherModule?.institutions_count || 0}
                                              </strong>{' '}
                                              inst.
                                            </Text>
                                          </Flex>
                                        </Flex>
                                      );
                                    })}
                                  {moduleOptions.length > 5 && (
                                    <Text
                                      fontSize="xs"
                                      color="content.subtle"
                                      fontStyle="italic"
                                      mt={1}
                                    >
                                      + {moduleOptions.length - 5} outros templates disponíveis
                                    </Text>
                                  )}
                                </Flex>
                              </Box>
                            )}

                            <Box mt={3} p={2} bg="blue.100" borderRadius="md">
                              <Text fontSize="xs" color="blue.800" fontWeight="medium">
                                💡 <strong>O que são Templates?</strong>
                              </Text>
                              <Text fontSize="xs" color="blue.700" mt={1}>
                                Os templates contêm Conteúdos {'>'} Categorias de materiais,
                                tópicos, avaliações e materiais extras. Você terá{' '}
                                {moduleDetails.templates_count || 0} template(s) para revisar e
                                ativar após criar a instituição.
                              </Text>
                            </Box>

                            <Text fontSize="xs" color="content.body" mt={3} fontStyle="italic">
                              📝 Após concluir o cadastro, acesse a tela{' '}
                              <Text as="span" fontWeight="bold">
                                Vincular Templates
                              </Text>{' '}
                              para revisar e ativar/desativar os itens desejados individualmente.
                            </Text>
                          </>
                        ) : (
                          <Text fontSize="xs" color="content.body">
                            Selecione um template para ver os detalhes...
                          </Text>
                        )}
                      </Box>
                    </details>
                  </Box>
                )}
              </Box>
            )}

            {isDefaultTemplateSelected && (
              <Box flexBasis="100%">
                <Alert variant="info">
                  <AlertTitle>Template padrão será aplicado automaticamente</AlertTitle>
                  <AlertDescription>
                    A seed completa de materiais, categorias e conteúdos será vinculada à
                    instituição. Você poderá revisar e ajustar os itens na tela{' '}
                    <Text
                      as="a"
                      href="/templates/link"
                      target="_blank"
                      rel="noopener noreferrer"
                      fontWeight="bold"
                      textDecoration="underline"
                    >
                      Vincular Templates
                    </Text>{' '}
                    após concluir o cadastro.
                  </AlertDescription>
                </Alert>
              </Box>
            )}

            {!isDefaultTemplateSelected && templateStrategyValue?.value === 'MANUAL' && (
              <Box flexBasis="100%">
                <Alert variant="warning">
                  <AlertTitle>Vinculação manual de templates</AlertTitle>
                  <AlertDescription>
                    {moduleSelectedValue
                      ? `Você selecionou "${moduleSelectedValue.label}" como template personalizado. `
                      : 'Selecione um template personalizado acima ou '}
                    Você precisará configurar manualmente os materiais e categorias na tela{' '}
                    <Text
                      as="a"
                      href="/templates/link"
                      target="_blank"
                      rel="noopener noreferrer"
                      fontWeight="bold"
                      textDecoration="underline"
                    >
                      Vincular Templates
                    </Text>{' '}
                    após criar a instituição.
                  </AlertDescription>
                </Alert>
              </Box>
            )}

            <Box flex={2} minW="240px">
              <MaskedInputForm
                name={cellphone?.name}
                label={cellphone?.label}
                placeholder={cellphone?.placeholder}
                control={control}
                errors={errors}
                mask="(99) 99999-9999"
              />
            </Box>

            <Box flex={2} minW="240px">
              <InputForm
                name={site?.name}
                label={site?.label}
                placeholder={site?.placeholder}
                isRequired
                register={register}
                errors={errors}
              />
            </Box>

            <Box flex={1} minW="200px">
              <SwitchInputForm
                name={status?.name}
                label={status?.label}
                errors={errors}
                control={control}
              />
            </Box>
          </Flex>
        </FormSection>

        <FormSection title="Endereço">
          <FormRow>
            <CepField
              name={codePost?.name}
              label={codePost?.label}
              placeholder={codePost?.placeholder}
              control={control}
              errors={errors}
              isLoading={loadingCodepost}
              notFoundMessage={errorCodepost?.status === 404 ? errorCodepost?.msg : undefined}
            />
            <InputForm
              name={city?.name}
              label={city?.label}
              placeholder={city?.placeholder}
              isDisabled
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={state?.name}
              label={state?.label}
              placeholder={state?.placeholder}
              isDisabled
              isRequired
              register={register}
              errors={errors}
            />
          </FormRow>

          <FormRow>
            <InputForm
              name={street?.name}
              label={street?.label}
              placeholder={street?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={number?.name}
              label={number?.label}
              placeholder={number?.placeholder}
              type="number"
              register={register}
              errors={errors}
            />
            <InputForm
              name={district?.name}
              label={district?.label}
              placeholder={district?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={complement?.name}
              label={complement?.label}
              placeholder={complement?.placeholder}
              register={register}
              errors={errors}
            />
          </FormRow>
        </FormSection>

        <FormSection
          title="Responsável"
          description={
            itemId
              ? 'Vincule usuários adicionais a esta instituição. Ajustes de permissão ficam na tela Permissões.'
              : 'Busque um usuário existente ou cadastre um novo responsável pela instituição.'
          }
        >
          {itemId && defaultValues?.responsible_user && (
            <Box>
              <FormLabel mb="8px">Responsável principal</FormLabel>
              <Flex
                align="center"
                gap="12px"
                p="8px"
                pr="12px"
                borderRadius="lg"
                border="1px solid"
                borderColor="line.input"
                bg="surface.base"
                boxShadow="control"
              >
                <Avatar
                  size="sm"
                  w="32px"
                  h="32px"
                  name={defaultValues.responsible_user.name}
                  bg="surface.selected"
                  color="content.body"
                  fontSize="12px"
                  fontWeight={500}
                />
                <Box flex="1" minW={0}>
                  <Text fontSize="13px" lineHeight="20px" fontWeight={500} color="content.strong">
                    {defaultValues.responsible_user.name}
                  </Text>
                  <Text fontSize="12px" lineHeight="16px" color="content.subtle" isTruncated>
                    {[
                      defaultValues.responsible_user.email,
                      defaultValues.responsible_user.cell_phone,
                    ]
                      .filter(Boolean)
                      .join(' · ')}
                  </Text>
                </Box>
                <Badge variant="neutral">Principal</Badge>
              </Flex>
            </Box>
          )}

          <ResponsiblePicker
            label={itemId ? 'Responsáveis adicionais' : 'Responsáveis'}
            searchInputId="institution-responsible-search"
            searchPlaceholder="Buscar responsável por nome ou email"
            isSearching={isSearchingUsers}
            isLoadingEligible={loadingEligibleUsers}
            isDisabled={!watch('secretary_id')}
            disabledHint='Selecione uma secretaria ou "Sem Secretaria" acima para habilitar a busca.'
            searchResults={userSearchResults}
            eligibleUsers={eligibleUsers}
            selectedUsers={selectedExistingUsers}
            newResponsible={itemId ? null : manualResponsible}
            error={manualResponsibleError}
            onSearchChange={handleUserSearchTerm}
            onSelectUser={handleSelectExistingUser}
            onRemoveUser={handleRemoveExistingUser}
            onCreateNew={itemId ? undefined : () => setNewResponsibleOpen(true)}
            onEditNew={() => setNewResponsibleOpen(true)}
            onRemoveNew={clearManualResponsible}
            showPrimaryBadge={!itemId}
            renderResultBadge={(user) =>
              user.is_institution_responsible ? (
                <Badge variant="warning">Já é responsável</Badge>
              ) : undefined
            }
          />
          <NewResponsibleDialog
            isOpen={newResponsibleOpen}
            onClose={() => setNewResponsibleOpen(false)}
            onSubmit={applyManualResponsible}
            initialValue={manualResponsible}
            defaultFunction="Responsável pela instituição"
            entityLabel="instituição"
          />
        </FormSection>

        <FormActions cancelTo="/institutions/list" isLoading={isSubmitting} />
      </Box>
    </FormShell>
  );
}
